{
  "level": "mt10mv",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:mt10mv",
    "objects": "AREAS.E3:mt10mv.e3",
    "mesh": "TREES.E3:mt10mv.e3"
  },
  "spawn_point": {
    "position": [
      0.0,
      0.0,
      0.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      0.0,
      100.0,
      0.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      0.0,
      0.0,
      0.0
    ],
    "bbox_max": [
      0.0,
      0.0,
      0.0
    ],
    "vertex_count": 0,
    "vertices": []
  },
  "sectors": [
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3342.937744140625,
      "bbox_min": [
        -3390.6396484375,
        -3342.937744140625,
        1275.0
      ],
      "bbox_max": [
        -3378.288818359375,
        -3342.937744140625,
        1295.0
      ],
      "face_count": 2
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: hangdr",
      "entity_class": "CSlidingDoor",
      "piece_name": "hangdr",
      "offset": 5189,
      "centroid": [
        -215.9000244140625,
        -2312.25,
        829.7999877929688
      ],
      "bbox_min": [
        -223.199951171875,
        -2313.199951171875,
        824.7999877929688
      ],
      "bbox_max": [
        -208.60009765625,
        -2311.300048828125,
        834.7999877929688
      ],
      "dimensions_source": {
        "span_x": 14.599853515625,
        "span_y": 1.89990234375,
        "height_z": 10.0,
        "door_width": 14.599853515625,
        "door_depth": 1.89990234375,
        "leaf_depth": 1.85990234375,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          -1.0,
          -0.0
        ]
      },
      "vertices": [
        [
          -223.199951171875,
          -2311.300048828125,
          834.7999877929688
        ],
        [
          -223.199951171875,
          -2313.199951171875,
          834.7999877929688
        ],
        [
          -208.60009765625,
          -2311.300048828125,
          834.7999877929688
        ],
        [
          -208.60009765625,
          -2313.199951171875,
          834.7999877929688
        ],
        [
          -208.60009765625,
          -2313.199951171875,
          824.7999877929688
        ],
        [
          -208.60009765625,
          -2311.300048828125,
          824.7999877929688
        ],
        [
          -223.199951171875,
          -2311.300048828125,
          824.7999877929688
        ],
        [
          -223.199951171875,
          -2313.199951171875,
          824.7999877929688
        ]
      ],
      "plane_distance": -2313.2,
      "authentic_texture": "chkptdoor1"
    }
  ],
  "tutorial_messages": []
}